import { render, staticRenderFns } from "./IndexingStudentData.vue?vue&type=template&id=1501790e&"
import script from "./IndexingStudentData.vue?vue&type=script&lang=js&"
export * from "./IndexingStudentData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports